import './CtaPreview.scss'

import {Background, Picture} from '@codeurs/front'
import {ImageType, Mod, WysiwygType} from '../../../types'
import {Styler, style} from '../../../util/style'

import {Link} from '../../../util/link'
import React from 'react'
import {Theme} from '../../Theme'

const styles: Styler = style('ctapreview')

export type CtaPreviewType = {
	url: string
	title: string
	price: number
	image?: ImageType
	preview_blur?: boolean
	preview_image: ImageType
	preview_title: string
	preview_text: WysiwygType
	hero_image: ImageType
	hero_title: string
	hero_text: WysiwygType
	text?: WysiwygType
	btnlabel?: string
	mod?: Mod<'large'>
}

export const CtaPreview: React.FC<CtaPreviewType> = ({
	url,
	title: pageTitle,
	price,
	preview_blur,
	preview_image,
	preview_title,
	preview_text,
	hero_image,
	hero_title,
	hero_text,
	mod,
	image,
	text,
	btnlabel
}) => {
	const ctaImage = preview_image || hero_image || image
	const title = preview_title || hero_title || pageTitle
	const ctaText = text || preview_text || hero_text
	const ctaLabel = btnlabel || title
	if (!ctaImage && !title && !ctaText) return null

	return (
		<div className={styles().mod(mod)}>
			{ctaImage && ctaImage.src && (
				<div className={styles('image').mod({blur: preview_blur})}>
					<Background className={styles('image-bg')} img={ctaImage} />
					{preview_blur && (
						<Picture className={styles('image-img')} {...ctaImage} />
					)}
				</div>
			)}
			<div className={styles('content')}>
				<Theme.H2 className={styles('content-title')} mod="bold">
					<Link to={url}>{title}</Link>
				</Theme.H2>
				{ctaText && (
					<div className={styles('content-text')}>
						<Theme.Wysiwyg>{ctaText}</Theme.Wysiwyg>
					</div>
				)}
				{price && <div className={styles('content-price')}>€{price}</div>}
				{url && (
					<div className={styles('content-button')}>
						<Theme.Button to={url} mod={['outline', 'whitebg']}>
							{ctaLabel}
						</Theme.Button>
					</div>
				)}
			</div>
		</div>
	)
}
